var RegistrationStatus;
(function (RegistrationStatus) {
    RegistrationStatus[RegistrationStatus["RESERVED"] = 1] = "RESERVED";
    RegistrationStatus[RegistrationStatus["MAYBE"] = 7] = "MAYBE";
    RegistrationStatus[RegistrationStatus["EXCUSED"] = 8] = "EXCUSED";
})(RegistrationStatus || (RegistrationStatus = {}));
export default RegistrationStatus;
